<div id="customize-product-button" class="hmf-mx-s hmf-mx-m-0">
	<a
		hmf-button
		variant="secondary"
		class="hmf-mt-xs hmf-mb-m"
		[ariaLabel]="'Customize This Product'"
		[href]="customSeoUrl"
		(click)="registerAnalytics()"
		[dataEm]="'pdp-customizethis'"
		text="CUSTOMIZE IT"
	></a>
</div>
